import PickUpHome from "./PickUpHome";

export default PickUpHome;
